module.exports = __webpack_public_path__ + "img/30.ecbbde05.png";